// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/occto_master_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BusinessPurpose } from "../../bfftypes/v1/business_purpose_pb";
import { file_bfftypes_v1_business_purpose } from "../../bfftypes/v1/business_purpose_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { GenerationSaleSubKind } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/occto_master_model.proto.
 */
export const file_bffuser_v1_occto_master_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_business_purpose, file_bfftypes_v1_license_type, file_bfftypes_v1_plan_submission, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * MasterReferenceBreakdownItem mirrors backend
 * internalapi.v1.MasterReferenceBreakdownItem 1:1.
 *
 * @generated from message bffuser.v1.MasterReferenceBreakdownItem
 */
export type MasterReferenceBreakdownItem = Message<"bffuser.v1.MasterReferenceBreakdownItem"> & {
  /**
   * @generated from field: bffuser.v1.MasterReferrerKind referrer_kind = 1;
   */
  referrerKind: MasterReferrerKind;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.MasterReferenceBreakdownItem.
 * Use `create(MasterReferenceBreakdownItemSchema)` to create a new message.
 */
export const MasterReferenceBreakdownItemSchema: GenMessage<MasterReferenceBreakdownItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 0);

/**
 * MasterDeleteBlockedByReferences is attached as a Connect error detail
 * when Delete<X>Master is rejected with FailedPrecondition because the
 * target is still referenced by other master / plan rows (index.md
 * AC-MOI-009). Mirrors backend internalapi.v1.MasterDeleteBlockedByReferences
 * 1:1; the BFF handler unpacks the backend gRPC status detail and
 * re-attaches it as this bffuser.v1 type.
 *
 * @generated from message bffuser.v1.MasterDeleteBlockedByReferences
 */
export type MasterDeleteBlockedByReferences = Message<"bffuser.v1.MasterDeleteBlockedByReferences"> & {
  /**
   * @generated from field: bffuser.v1.MasterSubjectKind subject_kind = 1;
   */
  subjectKind: MasterSubjectKind;

  /**
   * @generated from field: string subject_display_name = 2;
   */
  subjectDisplayName: string;

  /**
   * @generated from field: repeated bffuser.v1.MasterReferenceBreakdownItem breakdown = 3;
   */
  breakdown: MasterReferenceBreakdownItem[];
};

/**
 * Describes the message bffuser.v1.MasterDeleteBlockedByReferences.
 * Use `create(MasterDeleteBlockedByReferencesSchema)` to create a new message.
 */
export const MasterDeleteBlockedByReferencesSchema: GenMessage<MasterDeleteBlockedByReferences> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 1);

/**
 * BgMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListBgMasters. Mirrors backend
 * internalapi.v1.BgMasterListItem 1:1; the BFF handler converts enum
 * values from types.v1 / internalapi.v1 to bffuser.v1 equivalents.
 *
 * @generated from message bffuser.v1.BgMasterListItem
 */
export type BgMasterListItem = Message<"bffuser.v1.BgMasterListItem"> & {
  /**
   * UUID surrogate primary key. Use this as the navigation key when
   * opening the detail / edit modal in the future.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 4;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: string bg_name = 5;
   */
  bgName: string;

  /**
   * Derived, not stored (指示書 334): the power type today (JST) of the plants that belong to the
   * BG, present for 発電 BGs only. UNSPECIFIED = 未定.
   *
   * @generated from field: optional bffuser.v1.PowerType power_type = 6;
   */
  powerType?: PowerType;

  /**
   * Number of bg_member rows attached to this BG (member-count
   * aggregate; the member rows themselves are not surfaced).
   *
   * @generated from field: int32 member_count = 7;
   */
  memberCount: number;

  /**
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * 配下発電所数. A generation BG: the number of memberships valid today,
   * derived from the plant entries of 発電販売計画マスタ (the plant rows that
   * name this BG). 0 for every other BG (the screen shows "—").
   *
   * @generated from field: int32 plant_count = 10;
   */
  plantCount: number;

  /**
   * Effective-from date (inclusive). Surfaced so the list screen can
   * compute the 3-value status (有効 / 適用前 / 失効) client-side.
   *
   * @generated from field: google.type.Date valid_from = 11;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 12;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.BgMasterListItem.
 * Use `create(BgMasterListItemSchema)` to create a new message.
 */
export const BgMasterListItemSchema: GenMessage<BgMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 2);

/**
 * BgMaster is the full detail message returned by
 * OcctoMasterService.GetBgMaster / CreateBgMaster / UpdateBgMaster.
 * Mirrors backend internalapi.v1.BgMaster without organization_id. The BFF
 * handler converts enum values from types.v1 / internalapi.v1 to
 * bffuser.v1 / bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.BgMaster
 */
export type BgMaster = Message<"bffuser.v1.BgMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO BG code (5 characters).
   *
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * BG license type.
   *
   * @generated from field: bfftypes.v1.LicenseType license_type = 4;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: string bg_name = 5;
   */
  bgName: string;

  /**
   * Derived, not stored (指示書 334): the power type today (JST) of the plants that belong to the
   * BG, present for 発電 BGs only. UNSPECIFIED = 未定.
   *
   * @generated from field: optional bffuser.v1.PowerType power_type = 6;
   */
  powerType?: PowerType;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string rep_business_master_id = 7;
   */
  repBusinessMasterId: string;

  /**
   * BG member list. Always non-empty.
   *
   * @generated from field: repeated bffuser.v1.BgMemberView members = 8;
   */
  members: BgMemberView[];

  /**
   * Effective-from date (inclusive). Mutable after creation.
   *
   * @generated from field: google.type.Date valid_from = 10;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 11;
   */
  validTo?: Date;

  /**
   * Contract ID number 1. Present only for generation BGs.
   *
   * @generated from field: optional string contract_id_no_1 = 12;
   */
  contractIdNo1?: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 14;
   */
  note?: string;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 15;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 17;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */
  updatedAt?: Timestamp;

  /**
   * 配下発電所リスト (generation-plant memberships). Always empty for
   * non-generation BGs.
   *
   * @generated from field: repeated bffuser.v1.BgPlantMembershipView plants = 19;
   */
  plants: BgPlantMembershipView[];

  /**
   * 電源特定コード (WheelingLinkCode). Only meaningful when
   * license_type == SELF_WHEELING; absent otherwise. Mirrors backend
   * internalapi.v1.BgMaster.wheeling_link_code 1:1.
   *
   * @generated from field: optional string wheeling_link_code = 20;
   */
  wheelingLinkCode?: string;
};

/**
 * Describes the message bffuser.v1.BgMaster.
 * Use `create(BgMasterSchema)` to create a new message.
 */
export const BgMasterSchema: GenMessage<BgMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 3);

/**
 * BgMemberView is the read-side representation of a BG member returned
 * within BgMaster.members.
 *
 * @generated from message bffuser.v1.BgMemberView
 */
export type BgMemberView = Message<"bffuser.v1.BgMemberView"> & {
  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * Denormalised business name snapshot.
   *
   * @generated from field: string business_name = 2;
   */
  businessName: string;

  /**
   * Whether this member is the own-company operator of this BG.
   *
   * @generated from field: bool is_own = 3;
   */
  isOwn: boolean;

  /**
   * Membership effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Membership effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.BgMemberView.
 * Use `create(BgMemberViewSchema)` to create a new message.
 */
export const BgMemberViewSchema: GenMessage<BgMemberView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 4);

/**
 * BgMemberInput is the write-side representation of a BG member used in
 * CreateBgMasterRequest.members and UpdateBgMasterRequest.members.
 *
 * @generated from message bffuser.v1.BgMemberInput
 */
export type BgMemberInput = Message<"bffuser.v1.BgMemberInput"> & {
  /**
   * UUID of the business master to link as a member.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * Whether this member is the own-company operator of this BG.
   *
   * @generated from field: bool is_own = 2;
   */
  isOwn: boolean;

  /**
   * Membership effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Membership effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.BgMemberInput.
 * Use `create(BgMemberInputSchema)` to create a new message.
 */
export const BgMemberInputSchema: GenMessage<BgMemberInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 5);

/**
 * BgPlantMembershipView is the read-side representation of one 配下発電所
 * (generation-plant membership) entry returned within BgMaster.plants.
 * Mirrors backend internalapi.v1.BgPlantMembershipView 1:1.
 *
 * @generated from message bffuser.v1.BgPlantMembershipView
 */
export type BgPlantMembershipView = Message<"bffuser.v1.BgPlantMembershipView"> & {
  /**
   * UUID of the linked plant master record.
   *
   * @generated from field: string plant_master_id = 1;
   */
  plantMasterId: string;

  /**
   * Denormalised plant system code snapshot.
   *
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * Denormalised plant name snapshot.
   *
   * @generated from field: string plant_name = 3;
   */
  plantName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.BgPlantMembershipView.
 * Use `create(BgPlantMembershipViewSchema)` to create a new message.
 */
export const BgPlantMembershipViewSchema: GenMessage<BgPlantMembershipView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 6);

/**
 * BgPlantMembershipInput is the write-side representation of one 配下
 * 発電所 entry used in CreateBgMasterRequest.plants and
 * UpdateBgMasterRequest.plants. Only accepted on generation BGs; enforced
 * by the backend entity layer.
 *
 * @generated from message bffuser.v1.BgPlantMembershipInput
 */
export type BgPlantMembershipInput = Message<"bffuser.v1.BgPlantMembershipInput"> & {
  /**
   * UUID of the plant master to link.
   *
   * @generated from field: string plant_master_id = 1;
   */
  plantMasterId: string;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 2;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 3;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.BgPlantMembershipInput.
 * Use `create(BgPlantMembershipInputSchema)` to create a new message.
 */
export const BgPlantMembershipInputSchema: GenMessage<BgPlantMembershipInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 7);

/**
 * BusinessMaster is the full detail message returned by
 * OcctoMasterService.GetBusinessMaster / CreateBusinessMaster /
 * UpdateBusinessMaster. Mirrors backend internalapi.v1.BusinessMaster
 * without organization_id. The BFF handler converts LicenseType values from types.v1
 * to bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.BusinessMaster
 */
export type BusinessMaster = Message<"bffuser.v1.BusinessMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 4-digit business code.
   *
   * @generated from field: string business_code = 2;
   */
  businessCode: string;

  /**
   * @generated from field: string business_name = 3;
   */
  businessName: string;

  /**
   * Multi-select license categories. May contain any of the five
   * values (発電 / 小売 / 送配電 / 需要抑制 / 自己託送).
   *
   * @generated from field: repeated bfftypes.v1.LicenseType license_types = 4;
   */
  licenseTypes: LicenseType[];

  /**
   * Acquisition purpose (取得目的): 通常 / 蓄電池 / 揚水 / 自己託送.
   * Independent of license_types (spec AC-04). Mirrors backend
   * internalapi.v1.BusinessMaster.purpose 1:1.
   *
   * @generated from field: bfftypes.v1.BusinessPurpose purpose = 5;
   */
  purpose: BusinessPurpose;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 8;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 10;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * 登録小売電気事業者 登録番号。任意。形式「A」+ 数字。Mirrors backend
   * internalapi.v1.BusinessMaster.registration_number 1:1.
   *
   * @generated from field: optional string registration_number = 12;
   */
  registrationNumber?: string;
};

/**
 * Describes the message bffuser.v1.BusinessMaster.
 * Use `create(BusinessMasterSchema)` to create a new message.
 */
export const BusinessMasterSchema: GenMessage<BusinessMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 8);

/**
 * SubmitterMaster is the full detail message returned by
 * OcctoMasterService.GetSubmitterMaster / CreateSubmitterMaster /
 * UpdateSubmitterMaster. Mirrors backend internalapi.v1.SubmitterMaster
 * without organization_id. The BFF handler converts enum values from types.v1 to
 * bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.SubmitterMaster
 */
export type SubmitterMaster = Message<"bffuser.v1.SubmitterMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 5-character submitter code.
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * @generated from field: string submitter_name = 3;
   */
  submitterName: string;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 4;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 6;
   */
  businessMasterId: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 7;
   */
  note?: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 8;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 9;
   */
  validTo?: Date;

  /**
   * BG members associated with this submitter.
   *
   * @generated from field: repeated bffuser.v1.SubmitterBgMember members = 10;
   */
  members: SubmitterBgMember[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 12;
   */
  createdBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 14;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.SubmitterMaster.
 * Use `create(SubmitterMasterSchema)` to create a new message.
 */
export const SubmitterMasterSchema: GenMessage<SubmitterMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 9);

/**
 * SubmitterMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListSubmitterMasters. Mirrors backend
 * internalapi.v1.SubmitterMasterListItem 1:1.
 *
 * @generated from message bffuser.v1.SubmitterMasterListItem
 */
export type SubmitterMasterListItem = Message<"bffuser.v1.SubmitterMasterListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 5-character submitter code.
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * @generated from field: string submitter_name = 3;
   */
  submitterName: string;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 4;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * Number of bg_member rows attached to this submitter.
   *
   * @generated from field: int32 member_count = 6;
   */
  memberCount: number;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;

  /**
   * OCCTO 4-digit business code of the linked business master (JOIN
   * projection; AC-010).
   *
   * @generated from field: string business_code = 9;
   */
  businessCode: string;

  /**
   * Effective-from date (inclusive). Surfaced so the list screen can
   * compute the 3-value status (有効 / 適用前 / 失効) client-side.
   *
   * @generated from field: google.type.Date valid_from = 10;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 11;
   */
  validTo?: Date;

  /**
   * Linked business master name (JOIN projection; mirrors internalapi.v1).
   *
   * @generated from field: string business_name = 12;
   */
  businessName: string;
};

/**
 * Describes the message bffuser.v1.SubmitterMasterListItem.
 * Use `create(SubmitterMasterListItemSchema)` to create a new message.
 */
export const SubmitterMasterListItemSchema: GenMessage<SubmitterMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 10);

/**
 * SubmitterBgMember is the read-side representation of a BG member
 * returned within SubmitterMaster.members.
 *
 * @generated from message bffuser.v1.SubmitterBgMember
 */
export type SubmitterBgMember = Message<"bffuser.v1.SubmitterBgMember"> & {
  /**
   * UUID of the linked BG master record.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * Denormalised BG name snapshot.
   *
   * @generated from field: string bg_name = 2;
   */
  bgName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SubmitterBgMember.
 * Use `create(SubmitterBgMemberSchema)` to create a new message.
 */
export const SubmitterBgMemberSchema: GenMessage<SubmitterBgMember> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 11);

/**
 * SubmitterBgMemberInput is the write-side representation of a BG member
 * used in CreateSubmitterMasterRequest.members and
 * UpdateSubmitterMasterRequest.members.
 *
 * @generated from message bffuser.v1.SubmitterBgMemberInput
 */
export type SubmitterBgMemberInput = Message<"bffuser.v1.SubmitterBgMemberInput"> & {
  /**
   * UUID of the BG master to link.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * @generated from field: string bg_name = 2;
   */
  bgName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SubmitterBgMemberInput.
 * Use `create(SubmitterBgMemberInputSchema)` to create a new message.
 */
export const SubmitterBgMemberInputSchema: GenMessage<SubmitterBgMemberInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 12);

/**
 * TradingPartner is the full detail message returned by
 * OcctoMasterService.GetTradingPartner / CreateTradingPartner /
 * UpdateTradingPartner. Mirrors backend internalapi.v1.TradingPartner
 * without organization_id. The BFF handler converts enum values from types.v1 to
 * bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.TradingPartner
 */
export type TradingPartner = Message<"bffuser.v1.TradingPartner"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;

  /**
   * Account list. Always non-empty.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerAccount accounts = 4;
   */
  accounts: TradingPartnerAccount[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.TradingPartner.
 * Use `create(TradingPartnerSchema)` to create a new message.
 */
export const TradingPartnerSchema: GenMessage<TradingPartner> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 13);

/**
 * TradingPartnerAccount is one area account belonging to a
 * TradingPartner. Mirrors backend internalapi.v1.TradingPartnerAccount.
 *
 * @generated from message bffuser.v1.TradingPartnerAccount
 */
export type TradingPartnerAccount = Message<"bffuser.v1.TradingPartnerAccount"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * OCCTO account code.
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * Counterparty code name (取引先コード名称). Optional: may be an empty string (max 150 chars).
   *
   * @generated from field: string code_name = 4;
   */
  codeName: string;

  /**
   * Weekday contact entries. May be empty.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry weekday_contacts = 5;
   */
  weekdayContacts: TradingPartnerContactEntry[];

  /**
   * Holiday contact entries. May be empty.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry holiday_contacts = 6;
   */
  holidayContacts: TradingPartnerContactEntry[];

  /**
   * Representative flag (spec AC-OMT-004/028/029/030). Only a
   * representative account may hold contact entries.
   *
   * @generated from field: bool is_representative = 7;
   */
  isRepresentative: boolean;
};

/**
 * Describes the message bffuser.v1.TradingPartnerAccount.
 * Use `create(TradingPartnerAccountSchema)` to create a new message.
 */
export const TradingPartnerAccountSchema: GenMessage<TradingPartnerAccount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 14);

/**
 * TradingPartnerContactEntry is a single contact point within a
 * TradingPartnerAccount. Mirrors backend
 * internalapi.v1.TradingPartnerContactEntry.
 *
 * @generated from message bffuser.v1.TradingPartnerContactEntry
 */
export type TradingPartnerContactEntry = Message<"bffuser.v1.TradingPartnerContactEntry"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Department or section name (部署名).
   *
   * @generated from field: string department = 2;
   */
  department: string;

  /**
   * Contact person name. Absent when not recorded.
   *
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * Phone number.
   *
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * Email address. Absent when not recorded.
   *
   * @generated from field: optional string email = 5;
   */
  email?: string;
};

/**
 * Describes the message bffuser.v1.TradingPartnerContactEntry.
 * Use `create(TradingPartnerContactEntrySchema)` to create a new message.
 */
export const TradingPartnerContactEntrySchema: GenMessage<TradingPartnerContactEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 15);

/**
 * TradingPartnerListItem is the read-side projection returned by
 * OcctoMasterService.List*Partners RPCs. Mirrors backend
 * internalapi.v1.TradingPartnerListItem 1:1.
 *
 * @generated from message bffuser.v1.TradingPartnerListItem
 */
export type TradingPartnerListItem = Message<"bffuser.v1.TradingPartnerListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 5;
   */
  updatedBy?: string;

  /**
   * Account list for this partner (area + OCCTO code per account).
   * Used by the list screen to render area chips and tooltips.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerListItemAccount accounts = 6;
   */
  accounts: TradingPartnerListItemAccount[];
};

/**
 * Describes the message bffuser.v1.TradingPartnerListItem.
 * Use `create(TradingPartnerListItemSchema)` to create a new message.
 */
export const TradingPartnerListItemSchema: GenMessage<TradingPartnerListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 16);

/**
 * TradingPartnerListItemAccount holds the area and OCCTO code for one
 * account belonging to a TradingPartner, surfaced in the list view.
 *
 * code_name / weekday_contacts / holiday_contacts let the list screen's
 * child rows (spec AC-T09 / AC-T10) render each account's 取引先コード名称 and
 * contact details without an extra GetTradingPartner detail fetch.
 * Mirrors internalapi.v1.TradingPartnerListItemAccount 1:1.
 *
 * @generated from message bffuser.v1.TradingPartnerListItemAccount
 */
export type TradingPartnerListItemAccount = Message<"bffuser.v1.TradingPartnerListItemAccount"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * OCCTO account code.
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Counterparty code name (取引先コード名称). Optional: may be an empty string.
   *
   * @generated from field: string code_name = 3;
   */
  codeName: string;

  /**
   * Weekday contact entries (平日昼間連絡先). May be empty.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry weekday_contacts = 4;
   */
  weekdayContacts: TradingPartnerContactEntry[];

  /**
   * Holiday contact entries (休日・夜間連絡先). May be empty.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry holiday_contacts = 5;
   */
  holidayContacts: TradingPartnerContactEntry[];
};

/**
 * Describes the message bffuser.v1.TradingPartnerListItemAccount.
 * Use `create(TradingPartnerListItemAccountSchema)` to create a new message.
 */
export const TradingPartnerListItemAccountSchema: GenMessage<TradingPartnerListItemAccount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 17);

/**
 * TradingPartnerAccountInput is the write-side representation of an account
 * used in CreateTradingPartnerRequest.accounts and
 * UpdateTradingPartnerRequest.accounts.
 *
 * @generated from message bffuser.v1.TradingPartnerAccountInput
 */
export type TradingPartnerAccountInput = Message<"bffuser.v1.TradingPartnerAccountInput"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * OCCTO account code. Coarse length constraint; detailed format varies by
   * license type and is enforced by the backend entity layer.
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Counterparty code name (取引先コード名称). Optional: may be an empty string (max 150 chars).
   *
   * @generated from field: string code_name = 3;
   */
  codeName: string;

  /**
   * Weekday contact entries. May be empty. Capped at 100 entries
   * (backend converter maps repeated index to int16 display_order).
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntryInput weekday_contacts = 4;
   */
  weekdayContacts: TradingPartnerContactEntryInput[];

  /**
   * Holiday contact entries. May be empty. Capped at 100 entries
   * (same rationale as weekday_contacts).
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntryInput holiday_contacts = 5;
   */
  holidayContacts: TradingPartnerContactEntryInput[];

  /**
   * Representative flag (spec AC-OMT-004/028/029/030, default true for a
   * newly added account — AC-OMT-030). Only a representative account may
   * carry weekday_contacts / holiday_contacts.
   *
   * @generated from field: bool is_representative = 6;
   */
  isRepresentative: boolean;
};

/**
 * Describes the message bffuser.v1.TradingPartnerAccountInput.
 * Use `create(TradingPartnerAccountInputSchema)` to create a new message.
 */
export const TradingPartnerAccountInputSchema: GenMessage<TradingPartnerAccountInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 18);

/**
 * TradingPartnerContactEntryInput is the write-side representation of a
 * contact entry used within TradingPartnerAccountInput.
 *
 * Every field is optional (spec AC-T04): a contact entry may be saved
 * with any subset filled in, so neither department nor phone declares a
 * min_len constraint. Mirrors internalapi.v1.TradingPartnerContactEntryInput.
 *
 * @generated from message bffuser.v1.TradingPartnerContactEntryInput
 */
export type TradingPartnerContactEntryInput = Message<"bffuser.v1.TradingPartnerContactEntryInput"> & {
  /**
   * Department or section name (連絡先名称). Optional. max_len 30 mirrors
   * internal API / backend entity / frontend zod (4722-master-input-char-limits 設計書).
   *
   * @generated from field: string department = 1;
   */
  department: string;

  /**
   * Contact person name (担当者). Absent when not recorded. When present, must not
   * be empty. max_len 30 mirrors internal API.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Phone number. Optional. max_len 15 = ITU-T E.164 max digits mirrored across
   * 4 layers.
   *
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * Email address. Absent when not recorded. When present, must be a
   * valid RFC 5321 email address. max_len 254 = RFC 5321 path max.
   *
   * @generated from field: optional string email = 4;
   */
  email?: string;
};

/**
 * Describes the message bffuser.v1.TradingPartnerContactEntryInput.
 * Use `create(TradingPartnerContactEntryInputSchema)` to create a new message.
 */
export const TradingPartnerContactEntryInputSchema: GenMessage<TradingPartnerContactEntryInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 19);

/**
 * PlanMasterCodeView is the read-side representation of one plan-master
 * code entry returned within a GenerationSalesMaster or
 * DemandProcurementMaster detail response. Mirrors
 * internalapi.v1.PlanMasterCodeView without organization_id.
 *
 * @generated from message bffuser.v1.PlanMasterCodeView
 */
export type PlanMasterCodeView = Message<"bffuser.v1.PlanMasterCodeView"> & {
  /**
   * OCCTO plan-submission code.
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * Counterparty code name (取引先コード名称). Optional: may be an empty string (max 150 chars).
   *
   * @generated from field: string code_name = 2;
   */
  codeName: string;

  /**
   * Whether this code is for internal (own-company) use.
   *
   * @generated from field: bool is_internal = 3;
   */
  isInternal: boolean;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlanMasterCodeView.
 * Use `create(PlanMasterCodeViewSchema)` to create a new message.
 */
export const PlanMasterCodeViewSchema: GenMessage<PlanMasterCodeView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 20);

/**
 * PlanMasterCodeInput is the write-side representation of one plan-master
 * code entry used in Create/UpdateGenerationSalesMasterRequest.codes and
 * Create/UpdateDemandProcurementMasterRequest.codes.
 *
 * @generated from message bffuser.v1.PlanMasterCodeInput
 */
export type PlanMasterCodeInput = Message<"bffuser.v1.PlanMasterCodeInput"> & {
  /**
   * OCCTO plan-submission code.
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * Counterparty code name (取引先コード名称). Optional: may be an empty string (max 150 chars).
   *
   * @generated from field: string code_name = 2;
   */
  codeName: string;

  /**
   * Whether this code is for internal (own-company) use.
   *
   * @generated from field: bool is_internal = 3;
   */
  isInternal: boolean;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlanMasterCodeInput.
 * Use `create(PlanMasterCodeInputSchema)` to create a new message.
 */
export const PlanMasterCodeInputSchema: GenMessage<PlanMasterCodeInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 21);

/**
 * PlanMasterBgView is the read-side representation of one plan-master BG
 * entry returned within a GenerationSalesMaster or DemandProcurementMaster
 * detail response.
 *
 * @generated from message bffuser.v1.PlanMasterBgView
 */
export type PlanMasterBgView = Message<"bffuser.v1.PlanMasterBgView"> & {
  /**
   * UUID of the linked BG master record.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * Denormalised BG name snapshot.
   *
   * @generated from field: string bg_name = 2;
   */
  bgName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlanMasterBgView.
 * Use `create(PlanMasterBgViewSchema)` to create a new message.
 */
export const PlanMasterBgViewSchema: GenMessage<PlanMasterBgView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 22);

/**
 * PlanMasterBgInput is the write-side representation of one plan-master BG
 * entry used in Create/UpdateGenerationSalesMasterRequest.bgs and
 * Create/UpdateDemandProcurementMasterRequest.bgs.
 *
 * @generated from message bffuser.v1.PlanMasterBgInput
 */
export type PlanMasterBgInput = Message<"bffuser.v1.PlanMasterBgInput"> & {
  /**
   * UUID of the BG master to link.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 2;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 3;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlanMasterBgInput.
 * Use `create(PlanMasterBgInputSchema)` to create a new message.
 */
export const PlanMasterBgInputSchema: GenMessage<PlanMasterBgInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 23);

/**
 * DemandProcurementBgInput is the write-side representation of one BG
 * entry used in Create/UpdateDemandProcurementMasterRequest.bgs. Unlike
 * PlanMasterBgInput (shared with generation-sales), this message carries
 * no period fields: each row follows the parent DemandProcurementMaster's
 * valid_from / valid_to. Mirrors backend internalapi.v1.DemandProcurementBgInput.
 *
 * @generated from message bffuser.v1.DemandProcurementBgInput
 */
export type DemandProcurementBgInput = Message<"bffuser.v1.DemandProcurementBgInput"> & {
  /**
   * UUID of the BG master to link.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;
};

/**
 * Describes the message bffuser.v1.DemandProcurementBgInput.
 * Use `create(DemandProcurementBgInputSchema)` to create a new message.
 */
export const DemandProcurementBgInputSchema: GenMessage<DemandProcurementBgInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 24);

/**
 * DemandProcurementBgView is the read-side representation of one BG entry
 * returned within a DemandProcurementMaster detail response. Mirrors
 * backend internalapi.v1.DemandProcurementBgView.
 *
 * @generated from message bffuser.v1.DemandProcurementBgView
 */
export type DemandProcurementBgView = Message<"bffuser.v1.DemandProcurementBgView"> & {
  /**
   * UUID of the linked BG master record.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * Denormalised BG name snapshot.
   *
   * @generated from field: string bg_name = 2;
   */
  bgName: string;
};

/**
 * Describes the message bffuser.v1.DemandProcurementBgView.
 * Use `create(DemandProcurementBgViewSchema)` to create a new message.
 */
export const DemandProcurementBgViewSchema: GenMessage<DemandProcurementBgView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 25);

/**
 * PlanMasterPlantView is the read-side representation of one plan-master
 * plant entry returned within a GenerationSalesMaster detail response.
 * Mirrors backend internalapi.v1.PlanMasterPlantView 1:1.
 *
 * @generated from message bffuser.v1.PlanMasterPlantView
 */
export type PlanMasterPlantView = Message<"bffuser.v1.PlanMasterPlantView"> & {
  /**
   * UUID of the linked plant master record.
   *
   * @generated from field: string plant_master_id = 1;
   */
  plantMasterId: string;

  /**
   * Denormalised plant system code snapshot.
   *
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * Denormalised plant name snapshot.
   *
   * @generated from field: string plant_name = 3;
   */
  plantName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;

  /**
   * UUID of the 所属 BG (bg_master) the plant row belongs to.
   *
   * @generated from field: string bg_master_id = 6;
   */
  bgMasterId: string;

  /**
   * BG code of the 所属 BG, joined from bg_master at read time.
   *
   * @generated from field: string bg_code = 7;
   */
  bgCode: string;

  /**
   * BG name of the 所属 BG, joined from bg_master at read time.
   *
   * @generated from field: string bg_name = 8;
   */
  bgName: string;
};

/**
 * Describes the message bffuser.v1.PlanMasterPlantView.
 * Use `create(PlanMasterPlantViewSchema)` to create a new message.
 */
export const PlanMasterPlantViewSchema: GenMessage<PlanMasterPlantView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 26);

/**
 * PlanMasterPlantInput is the write-side representation of one plan-master
 * plant entry used in Create/UpdateGenerationSalesMasterRequest.plants.
 * plant_code / plant_name are resolved server-side from the linked
 * PlantMaster (gen-sales-plant-master-select 設計書 §4).
 *
 * @generated from message bffuser.v1.PlanMasterPlantInput
 */
export type PlanMasterPlantInput = Message<"bffuser.v1.PlanMasterPlantInput"> & {
  /**
   * UUID of the plant master to link.
   *
   * @generated from field: string plant_master_id = 1;
   */
  plantMasterId: string;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 2;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 3;
   */
  validTo?: Date;

  /**
   * UUID of the 所属 BG (bg_master). Required; it must be one of the BG
   * entries (`bgs`) of the same request.
   *
   * @generated from field: string bg_master_id = 4;
   */
  bgMasterId: string;
};

/**
 * Describes the message bffuser.v1.PlanMasterPlantInput.
 * Use `create(PlanMasterPlantInputSchema)` to create a new message.
 */
export const PlanMasterPlantInputSchema: GenMessage<PlanMasterPlantInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 27);

/**
 * PlantMasterListItem is the read-side projection returned within
 * GetGenerationSalesPlanMasterFormOptionsResponse.plants, used to populate
 * the 発電所リスト dropdown (gen-sales-plant-master-select 設計書 §5).
 *
 * @generated from message bffuser.v1.PlantMasterListItem
 */
export type PlantMasterListItem = Message<"bffuser.v1.PlantMasterListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO plant system code (5 characters).
   *
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * @generated from field: string plant_name = 3;
   */
  plantName: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * 電源種別 (配下の電源ユニットから今日の値を導出。ユニットが無い・今日有効なものが無いと UNSPECIFIED = 未定).
   * 発電販売計画マスタの発電所候補を、決まっていて計画区分に合う種別だけに絞るのに使う.
   *
   * @generated from field: bffuser.v1.PowerType power_type = 5;
   */
  powerType: PowerType;
};

/**
 * Describes the message bffuser.v1.PlantMasterListItem.
 * Use `create(PlantMasterListItemSchema)` to create a new message.
 */
export const PlantMasterListItemSchema: GenMessage<PlantMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 28);

/**
 * SuppressionContractView is the read-side representation of one suppression
 * contract entry returned within a DemandSuppressionMaster detail response.
 *
 * @generated from message bffuser.v1.SuppressionContractView
 */
export type SuppressionContractView = Message<"bffuser.v1.SuppressionContractView"> & {
  /**
   * UUID of the suppression-side BG master.
   *
   * @generated from field: string suppression_bg_master_id = 1;
   */
  suppressionBgMasterId: string;

  /**
   * UUID of the partner-side BG master.
   *
   * @generated from field: string partner_bg_master_id = 2;
   */
  partnerBgMasterId: string;

  /**
   * UUID of the linked business master.
   *
   * @generated from field: string business_master_id = 3;
   */
  businessMasterId: string;

  /**
   * Contract identifier code.
   *
   * @generated from field: string contract_id = 4;
   */
  contractId: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 5;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 6;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SuppressionContractView.
 * Use `create(SuppressionContractViewSchema)` to create a new message.
 */
export const SuppressionContractViewSchema: GenMessage<SuppressionContractView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 29);

/**
 * SuppressionContractInput is the write-side representation of one suppression
 * contract entry used in Create/UpdateDemandSuppressionMasterRequest.contracts.
 *
 * @generated from message bffuser.v1.SuppressionContractInput
 */
export type SuppressionContractInput = Message<"bffuser.v1.SuppressionContractInput"> & {
  /**
   * UUID of the suppression-side BG master.
   *
   * @generated from field: string suppression_bg_master_id = 1;
   */
  suppressionBgMasterId: string;

  /**
   * UUID of the partner-side BG master.
   *
   * @generated from field: string partner_bg_master_id = 2;
   */
  partnerBgMasterId: string;

  /**
   * UUID of the linked business master.
   *
   * @generated from field: string business_master_id = 3;
   */
  businessMasterId: string;

  /**
   * Contract identifier code. max_len 20 = internal API `SuppressionContractInput.contract_id`
   * / backend entity `demandSuppressionContractIDMaxLen` / DB varchar(20) と 3 層一致
   * (spec demand-suppression-plan.md, 4722-master-input-char-limits 設計書)。
   *
   * @generated from field: string contract_id = 4;
   */
  contractId: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 5;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 6;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SuppressionContractInput.
 * Use `create(SuppressionContractInputSchema)` to create a new message.
 */
export const SuppressionContractInputSchema: GenMessage<SuppressionContractInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 30);

/**
 * SuppressionPartnerBgView is the read-side representation of one suppression
 * partner-BG entry returned within a DemandSuppressionMaster detail response.
 *
 * @generated from message bffuser.v1.SuppressionPartnerBgView
 */
export type SuppressionPartnerBgView = Message<"bffuser.v1.SuppressionPartnerBgView"> & {
  /**
   * Which side of the contract this BG plays (procurement / sales).
   *
   * @generated from field: bffuser.v1.DemandSuppressionPartnerSide side = 1;
   */
  side: DemandSuppressionPartnerSide;

  /**
   * UUID of the partner-side BG master.
   *
   * @generated from field: string bg_master_id = 2;
   */
  bgMasterId: string;

  /**
   * Denormalised BG name snapshot.
   *
   * @generated from field: string bg_name = 3;
   */
  bgName: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SuppressionPartnerBgView.
 * Use `create(SuppressionPartnerBgViewSchema)` to create a new message.
 */
export const SuppressionPartnerBgViewSchema: GenMessage<SuppressionPartnerBgView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 31);

/**
 * SuppressionPartnerBgInput is the write-side representation of one suppression
 * partner-BG entry used in
 * Create/UpdateDemandSuppressionMasterRequest.partner_bgs.
 *
 * @generated from message bffuser.v1.SuppressionPartnerBgInput
 */
export type SuppressionPartnerBgInput = Message<"bffuser.v1.SuppressionPartnerBgInput"> & {
  /**
   * Which side of the contract this BG plays (procurement / sales).
   * UNSPECIFIED is rejected.
   *
   * @generated from field: bffuser.v1.DemandSuppressionPartnerSide side = 1;
   */
  side: DemandSuppressionPartnerSide;

  /**
   * UUID of the partner-side BG master.
   *
   * @generated from field: string bg_master_id = 2;
   */
  bgMasterId: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.SuppressionPartnerBgInput.
 * Use `create(SuppressionPartnerBgInputSchema)` to create a new message.
 */
export const SuppressionPartnerBgInputSchema: GenMessage<SuppressionPartnerBgInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 32);

/**
 * GenerationSalesMaster is the full detail message returned by
 * OcctoMasterService.GetGenerationSalesMaster /
 * CreateGenerationSalesMaster / UpdateGenerationSalesMaster. Mirrors
 * backend internalapi.v1.GenerationSalesMaster without organization_id.
 *
 * @generated from message bffuser.v1.GenerationSalesMaster
 */
export type GenerationSalesMaster = Message<"bffuser.v1.GenerationSalesMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * UUID of the linked submitter master record.
   *
   * @generated from field: string submitter_master_id = 2;
   */
  submitterMasterId: string;

  /**
   * OCCTO 5-character submitter code (denormalised snapshot).
   *
   * @generated from field: string submitter_code = 3;
   */
  submitterCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 4;
   */
  note?: string;

  /**
   * Plan-master code list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeView codes = 5;
   */
  codes: PlanMasterCodeView[];

  /**
   * Plan-master BG list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterBgView bgs = 6;
   */
  bgs: PlanMasterBgView[];

  /**
   * Plan-master plant list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterPlantView plants = 7;
   */
  plants: PlanMasterPlantView[];

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 8;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 10;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * 計画区分 (通常電源 / FIT 特例電源). Immutable after creation; required on
   * Create, absent from Update (generation-sales-plan-category 設計書).
   *
   * @generated from field: bfftypes.v1.GenerationSaleSubKind plan_category = 12;
   */
  planCategory: GenerationSaleSubKind;

  /**
   * Effective-from date (inclusive). Mutable after creation.
   *
   * @generated from field: google.type.Date valid_from = 13;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 14;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.GenerationSalesMaster.
 * Use `create(GenerationSalesMasterSchema)` to create a new message.
 */
export const GenerationSalesMasterSchema: GenMessage<GenerationSalesMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 33);

/**
 * GenerationSalesMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListGenerationSalesMasters.
 *
 * @generated from message bffuser.v1.GenerationSalesMasterListItem
 */
export type GenerationSalesMasterListItem = Message<"bffuser.v1.GenerationSalesMasterListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 5-character submitter code.
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Number of plan-master code entries.
   *
   * @generated from field: int32 code_count = 4;
   */
  codeCount: number;

  /**
   * Number of plan-master BG entries.
   *
   * @generated from field: int32 bg_count = 5;
   */
  bgCount: number;

  /**
   * Number of plan-master plant entries.
   *
   * @generated from field: int32 plant_count = 6;
   */
  plantCount: number;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 7;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * Area of the linked submitter master, used for the list-screen area
   * filter (derived; not stored on the plan master itself).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 9;
   */
  areaCode: AreaCode;

  /**
   * 計画区分 (通常電源 / FIT 特例電源). Used by the list-screen client-side
   * filter toggle (generation-sales-plan-category 設計書 §「List フィルタ」).
   *
   * @generated from field: bfftypes.v1.GenerationSaleSubKind plan_category = 10;
   */
  planCategory: GenerationSaleSubKind;

  /**
   * Effective-from date (inclusive). Surfaced so the list screen can
   * compute the 3-value status (有効 / 適用前 / 失効) client-side.
   *
   * @generated from field: google.type.Date valid_from = 11;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 12;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.GenerationSalesMasterListItem.
 * Use `create(GenerationSalesMasterListItemSchema)` to create a new message.
 */
export const GenerationSalesMasterListItemSchema: GenMessage<GenerationSalesMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 34);

/**
 * DemandProcurementMaster is the full detail message returned by
 * OcctoMasterService.GetDemandProcurementMaster /
 * CreateDemandProcurementMaster / UpdateDemandProcurementMaster. Mirrors
 * backend internalapi.v1.DemandProcurementMaster without organization_id.
 *
 * @generated from message bffuser.v1.DemandProcurementMaster
 */
export type DemandProcurementMaster = Message<"bffuser.v1.DemandProcurementMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * UUID of the linked BG master record.
   *
   * @generated from field: string bg_master_id = 2;
   */
  bgMasterId: string;

  /**
   * OCCTO 5-character BG code (denormalised snapshot).
   *
   * @generated from field: string bg_code = 3;
   */
  bgCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 4;
   */
  note?: string;

  /**
   * Plan-master code list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeView codes = 5;
   */
  codes: PlanMasterCodeView[];

  /**
   * Plan-master BG list. Uses DemandProcurementBgView (no per-row period).
   *
   * @generated from field: repeated bffuser.v1.DemandProcurementBgView bgs = 6;
   */
  bgs: DemandProcurementBgView[];

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 9;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Mutable after creation.
   *
   * @generated from field: google.type.Date valid_from = 11;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 12;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.DemandProcurementMaster.
 * Use `create(DemandProcurementMasterSchema)` to create a new message.
 */
export const DemandProcurementMasterSchema: GenMessage<DemandProcurementMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 35);

/**
 * DemandProcurementMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListDemandProcurementMasters.
 *
 * @generated from message bffuser.v1.DemandProcurementMasterListItem
 */
export type DemandProcurementMasterListItem = Message<"bffuser.v1.DemandProcurementMasterListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 5-character BG code.
   *
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Number of plan-master code entries.
   *
   * @generated from field: int32 code_count = 4;
   */
  codeCount: number;

  /**
   * Number of plan-master BG entries.
   *
   * @generated from field: int32 bg_count = 5;
   */
  bgCount: number;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 6;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * Area of the linked BG master, used for the list-screen area filter
   * (derived; not stored on the plan master itself).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 8;
   */
  areaCode: AreaCode;

  /**
   * Effective-from date (inclusive). Surfaced so the list screen can
   * compute the 3-value status (有効 / 適用前 / 失効) client-side.
   *
   * @generated from field: google.type.Date valid_from = 9;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 10;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.DemandProcurementMasterListItem.
 * Use `create(DemandProcurementMasterListItemSchema)` to create a new message.
 */
export const DemandProcurementMasterListItemSchema: GenMessage<DemandProcurementMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 36);

/**
 * DemandSuppressionMaster is the full detail message returned by
 * OcctoMasterService.GetDemandSuppressionMaster /
 * CreateDemandSuppressionMaster / UpdateDemandSuppressionMaster. Mirrors
 * backend internalapi.v1.DemandSuppressionMaster without organization_id.
 *
 * @generated from message bffuser.v1.DemandSuppressionMaster
 */
export type DemandSuppressionMaster = Message<"bffuser.v1.DemandSuppressionMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * UUID of the linked submitter master record.
   *
   * @generated from field: string submitter_master_id = 2;
   */
  submitterMasterId: string;

  /**
   * OCCTO 5-character submitter code (denormalised snapshot).
   *
   * @generated from field: string submitter_code = 3;
   */
  submitterCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 4;
   */
  note?: string;

  /**
   * Suppression contract list.
   *
   * @generated from field: repeated bffuser.v1.SuppressionContractView contracts = 5;
   */
  contracts: SuppressionContractView[];

  /**
   * Suppression partner-BG list.
   *
   * @generated from field: repeated bffuser.v1.SuppressionPartnerBgView partner_bgs = 6;
   */
  partnerBgs: SuppressionPartnerBgView[];

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 9;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Mutable after creation.
   *
   * @generated from field: google.type.Date valid_from = 11;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 12;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.DemandSuppressionMaster.
 * Use `create(DemandSuppressionMasterSchema)` to create a new message.
 */
export const DemandSuppressionMasterSchema: GenMessage<DemandSuppressionMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 37);

/**
 * DemandSuppressionMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListDemandSuppressionMasters.
 *
 * @generated from message bffuser.v1.DemandSuppressionMasterListItem
 */
export type DemandSuppressionMasterListItem = Message<"bffuser.v1.DemandSuppressionMasterListItem"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 5-character submitter code.
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Number of suppression contract entries.
   *
   * @generated from field: int32 contract_count = 4;
   */
  contractCount: number;

  /**
   * Number of suppression partner-BG entries.
   *
   * @generated from field: int32 partner_bg_count = 5;
   */
  partnerBgCount: number;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 6;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * Area of the linked submitter master, used for the list-screen area
   * filter (derived; not stored on the plan master itself).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 8;
   */
  areaCode: AreaCode;

  /**
   * Effective-from date (inclusive). Surfaced so the list screen can
   * compute the 3-value status (有効 / 適用前 / 失効) client-side.
   *
   * @generated from field: google.type.Date valid_from = 9;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 10;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.DemandSuppressionMasterListItem.
 * Use `create(DemandSuppressionMasterListItemSchema)` to create a new message.
 */
export const DemandSuppressionMasterListItemSchema: GenMessage<DemandSuppressionMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 38);

/**
 * PlantMaster is the full detail message returned by
 * OcctoMasterService.GetPlantMaster / CreatePlantMaster /
 * UpdatePlantMaster. Mirrors backend internalapi.v1.PlantMaster without organization_id.
 * The BFF handler converts enum values from internalapi.v1 /
 * types.v1 to bffuser.v1 / bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.PlantMaster
 */
export type PlantMaster = Message<"bffuser.v1.PlantMaster"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO plant system code (5 characters); immutable after creation.
   *
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * @generated from field: string plant_name = 3;
   */
  plantName: string;

  /**
   * @generated from field: string plant_name_abbr = 4;
   */
  plantNameAbbr: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * Derived, not stored (指示書 334): the power type on today (JST) of the units of the 系統コード.
   * UNSPECIFIED = 未定 (no valid unit today).
   *
   * @generated from field: bffuser.v1.PowerType power_type = 6;
   */
  powerType: PowerType;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 7;
   */
  voltageClass: VoltageClass;

  /**
   * Maximum receiving power in kW.
   *
   * @generated from field: google.type.Decimal max_receiving_power_kw = 8;
   */
  maxReceivingPowerKw?: Decimal;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string business_master_id = 9;
   */
  businessMasterId: string;

  /**
   * Contract ID number 2. Optional free-text.
   *
   * @generated from field: optional string contract_id_no_2 = 10;
   */
  contractIdNo2?: string;

  /**
   * Display priority (1–99). Optional; absent when not set (AC-05/AC-06).
   *
   * @generated from field: optional int32 priority = 11;
   */
  priority?: number;

  /**
   * Pro-rata internal priority. Optional.
   *
   * @generated from field: optional int32 pro_rata_priority = 12;
   */
  proRataPriority?: number;

  /**
   * Optional free-text note.
   *
   * @generated from field: optional string note = 13;
   */
  note?: string;

  /**
   * Joint-ownership member list. Always non-empty.
   *
   * @generated from field: repeated bffuser.v1.PlantMemberView members = 14;
   */
  members: PlantMemberView[];

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 15;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 16;
   */
  validTo?: Date;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 17;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 19;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.PlantMaster.
 * Use `create(PlantMasterSchema)` to create a new message.
 */
export const PlantMasterSchema: GenMessage<PlantMaster> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 39);

/**
 * PlantMemberView is the read-side representation of a joint-ownership
 * member returned within PlantMaster.members.
 *
 * @generated from message bffuser.v1.PlantMemberView
 */
export type PlantMemberView = Message<"bffuser.v1.PlantMemberView"> & {
  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * Denormalised business name snapshot.
   *
   * @generated from field: string business_name = 2;
   */
  businessName: string;

  /**
   * Whether this member is the ebalance-tenant's own company among the
   * joint owners (= BgMember.is_own pattern). At most one member per plant
   * may be is_own; zero is also allowed. The representative owner is NOT a
   * member flag: it is expressed by PlantMaster.business_master_id being
   * present in members.
   *
   * @generated from field: bool is_own = 3;
   */
  isOwn: boolean;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlantMemberView.
 * Use `create(PlantMemberViewSchema)` to create a new message.
 */
export const PlantMemberViewSchema: GenMessage<PlantMemberView> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 40);

/**
 * PlantMemberInput is the write-side representation of a joint-ownership
 * member used in CreatePlantMasterRequest.members and
 * UpdatePlantMasterRequest.members.
 *
 * @generated from message bffuser.v1.PlantMemberInput
 */
export type PlantMemberInput = Message<"bffuser.v1.PlantMemberInput"> & {
  /**
   * UUID of the business master to link as a member.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * Whether this member is the ebalance-tenant's own company among the
   * joint owners (= BgMember.is_own pattern). At most one member may be
   * is_own; zero is also allowed. The representative owner is expressed by
   * CreatePlantMasterRequest.business_master_id / UpdatePlantMasterRequest
   * .business_master_id being present in members, not by a member flag.
   *
   * @generated from field: bool is_own = 2;
   */
  isOwn: boolean;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 3;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 4;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.PlantMemberInput.
 * Use `create(PlantMemberInputSchema)` to create a new message.
 */
export const PlantMemberInputSchema: GenMessage<PlantMemberInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 41);

/**
 * BusinessMasterListItem is the read-side projection returned by
 * OcctoMasterService.ListBusinessMasters. Mirrors backend
 * internalapi.v1.BusinessMasterListItem 1:1; the BFF handler converts
 * LicenseType values from types.v1 to bfftypes.v1 equivalents.
 *
 * @generated from message bffuser.v1.BusinessMasterListItem
 */
export type BusinessMasterListItem = Message<"bffuser.v1.BusinessMasterListItem"> & {
  /**
   * UUID surrogate primary key. Use this as the navigation key when
   * opening the detail / edit modal in the future.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO 4-digit business code.
   *
   * @generated from field: string business_code = 2;
   */
  businessCode: string;

  /**
   * @generated from field: string business_name = 3;
   */
  businessName: string;

  /**
   * Multi-select license categories. May contain any of the five
   * values (発電 / 小売 / 送配電 / 需要抑制 / 自己託送).
   *
   * @generated from field: repeated bfftypes.v1.LicenseType license_types = 4;
   */
  licenseTypes: LicenseType[];

  /**
   * @generated from field: optional string updated_by = 5;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Consumed by the list screen's
   * expiry filter and effective-period status badge.
   *
   * @generated from field: google.type.Date valid_from = 7;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 8;
   */
  validTo?: Date;

  /**
   * Acquisition purpose (取得目的): 通常 / 蓄電池 / 揚水 / 自己託送 (spec
   * AC-05, displayed as a column right of license_types). Mirrors
   * backend internalapi.v1.BusinessMasterListItem.purpose 1:1 (field 5
   * is already used by updated_by on this list-item message).
   *
   * @generated from field: bfftypes.v1.BusinessPurpose purpose = 9;
   */
  purpose: BusinessPurpose;

  /**
   * 登録小売電気事業者 登録番号。任意。一覧の事業者コード左列 (AC-OMU-013、
   * issue #6504) に表示する。Mirrors backend
   * internalapi.v1.BusinessMasterListItem.registration_number 1:1.
   *
   * @generated from field: optional string registration_number = 10;
   */
  registrationNumber?: string;
};

/**
 * Describes the message bffuser.v1.BusinessMasterListItem.
 * Use `create(BusinessMasterListItemSchema)` to create a new message.
 */
export const BusinessMasterListItemSchema: GenMessage<BusinessMasterListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 42);

/**
 * AreaChangeRegistration is a 発電販売計画マスタ / BG that lists the 系統コード,
 * with the area of that registration itself (the 提出者's / the BG's area).
 *
 * @generated from message bffuser.v1.AreaChangeRegistration
 */
export type AreaChangeRegistration = Message<"bffuser.v1.AreaChangeRegistration"> & {
  /**
   * @generated from field: bffuser.v1.AreaChangeRegistrationKind kind = 1;
   */
  kind: AreaChangeRegistrationKind;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.AreaChangeRegistration.
 * Use `create(AreaChangeRegistrationSchema)` to create a new message.
 */
export const AreaChangeRegistrationSchema: GenMessage<AreaChangeRegistration> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 43);

/**
 * PlantAreaMismatchUnit is a unit that uses a 系統コード while its 発電所 is in
 * another area (エリア不一致), seen from the 系統コード.
 *
 * @generated from message bffuser.v1.PlantAreaMismatchUnit
 */
export type PlantAreaMismatchUnit = Message<"bffuser.v1.PlantAreaMismatchUnit"> & {
  /**
   * @generated from field: string unit_name = 1;
   */
  unitName: string;

  /**
   * @generated from field: string site_name = 2;
   */
  siteName: string;

  /**
   * The area of the unit's 発電所.
   *
   * @generated from field: bfftypes.v1.AreaCode site_area_code = 3;
   */
  siteAreaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.PlantAreaMismatchUnit.
 * Use `create(PlantAreaMismatchUnitSchema)` to create a new message.
 */
export const PlantAreaMismatchUnitSchema: GenMessage<PlantAreaMismatchUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 44);

/**
 * SiteAreaMismatchUnit is a unit of a 発電所 whose 系統コード is in another area
 * (エリア不一致), seen from the 発電所.
 *
 * @generated from message bffuser.v1.SiteAreaMismatchUnit
 */
export type SiteAreaMismatchUnit = Message<"bffuser.v1.SiteAreaMismatchUnit"> & {
  /**
   * @generated from field: string unit_name = 1;
   */
  unitName: string;

  /**
   * @generated from field: string plant_code = 2;
   */
  plantCode: string;

  /**
   * The area of the unit's 系統コード.
   *
   * @generated from field: bfftypes.v1.AreaCode plant_area_code = 3;
   */
  plantAreaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.SiteAreaMismatchUnit.
 * Use `create(SiteAreaMismatchUnitSchema)` to create a new message.
 */
export const SiteAreaMismatchUnitSchema: GenMessage<SiteAreaMismatchUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 45);

/**
 * PlantAreaChangeBlockedByRegistration mirrors internalapi.v1 (attached to the Connect error). It is the detail of
 * PlantMasterErrorReason.AREA_CHANGE_BLOCKED_BY_REGISTRATION (FailedPrecondition,
 * next to the google.rpc.ErrorInfo): the 系統コード is registered in a plan master /
 * BG of another area than the new one, so its area cannot be changed until it is
 * taken out of there.
 *
 * @generated from message bffuser.v1.PlantAreaChangeBlockedByRegistration
 */
export type PlantAreaChangeBlockedByRegistration = Message<"bffuser.v1.PlantAreaChangeBlockedByRegistration"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode to_area_code = 2;
   */
  toAreaCode: AreaCode;

  /**
   * @generated from field: repeated bffuser.v1.AreaChangeRegistration registrations = 3;
   */
  registrations: AreaChangeRegistration[];
};

/**
 * Describes the message bffuser.v1.PlantAreaChangeBlockedByRegistration.
 * Use `create(PlantAreaChangeBlockedByRegistrationSchema)` to create a new message.
 */
export const PlantAreaChangeBlockedByRegistrationSchema: GenMessage<PlantAreaChangeBlockedByRegistration> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 46);

/**
 * PlantAreaChangeNeedsConfirmation is the error detail of
 * PlantMasterErrorReason.AREA_CHANGE_NEEDS_CONFIRMATION: units whose 発電所 is in
 * another area than the new one. Resend with area_change_confirmed = true to save.
 *
 * @generated from message bffuser.v1.PlantAreaChangeNeedsConfirmation
 */
export type PlantAreaChangeNeedsConfirmation = Message<"bffuser.v1.PlantAreaChangeNeedsConfirmation"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode to_area_code = 2;
   */
  toAreaCode: AreaCode;

  /**
   * @generated from field: repeated bffuser.v1.PlantAreaMismatchUnit units = 3;
   */
  units: PlantAreaMismatchUnit[];
};

/**
 * Describes the message bffuser.v1.PlantAreaChangeNeedsConfirmation.
 * Use `create(PlantAreaChangeNeedsConfirmationSchema)` to create a new message.
 */
export const PlantAreaChangeNeedsConfirmationSchema: GenMessage<PlantAreaChangeNeedsConfirmation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 47);

/**
 * GenerationSiteAreaChangeNeedsConfirmation is the error detail of
 * GenerationSiteErrorReason.AREA_CHANGE_NEEDS_CONFIRMATION: units whose 系統コード is
 * in another area than the new one. Resend with area_change_confirmed = true to save.
 *
 * @generated from message bffuser.v1.GenerationSiteAreaChangeNeedsConfirmation
 */
export type GenerationSiteAreaChangeNeedsConfirmation = Message<"bffuser.v1.GenerationSiteAreaChangeNeedsConfirmation"> & {
  /**
   * @generated from field: string site_name = 1;
   */
  siteName: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode to_area_code = 2;
   */
  toAreaCode: AreaCode;

  /**
   * @generated from field: repeated bffuser.v1.SiteAreaMismatchUnit units = 3;
   */
  units: SiteAreaMismatchUnit[];
};

/**
 * Describes the message bffuser.v1.GenerationSiteAreaChangeNeedsConfirmation.
 * Use `create(GenerationSiteAreaChangeNeedsConfirmationSchema)` to create a new message.
 */
export const GenerationSiteAreaChangeNeedsConfirmationSchema: GenMessage<GenerationSiteAreaChangeNeedsConfirmation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 48);

/**
 * PowerTypeMixDetail is the error detail of PlantUnitErrorReason.POWER_TYPE_MIX (E1, FailedPrecondition):
 * another unit of the 系統コード, whose 有効期間 overlaps, has a different power type.
 *
 * @generated from message bffuser.v1.PowerTypeMixDetail
 */
export type PowerTypeMixDetail = Message<"bffuser.v1.PowerTypeMixDetail"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * The power type of the first of the other units (kept for older clients; see units).
   *
   * @generated from field: bffuser.v1.PowerType other_power_type = 2;
   */
  otherPowerType: PowerType;

  /**
   * Every other unit of the 系統コード whose 有効期間 overlaps and whose power type differs.
   *
   * @generated from field: repeated bffuser.v1.PowerTypeMixUnit units = 3;
   */
  units: PowerTypeMixUnit[];
};

/**
 * Describes the message bffuser.v1.PowerTypeMixDetail.
 * Use `create(PowerTypeMixDetailSchema)` to create a new message.
 */
export const PowerTypeMixDetailSchema: GenMessage<PowerTypeMixDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 49);

/**
 * PowerTypeMixUnit is one unit named in PowerTypeMixDetail.
 *
 * @generated from message bffuser.v1.PowerTypeMixUnit
 */
export type PowerTypeMixUnit = Message<"bffuser.v1.PowerTypeMixUnit"> & {
  /**
   * @generated from field: string unit_name = 1;
   */
  unitName: string;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 2;
   */
  powerType: PowerType;
};

/**
 * Describes the message bffuser.v1.PowerTypeMixUnit.
 * Use `create(PowerTypeMixUnitSchema)` to create a new message.
 */
export const PowerTypeMixUnitSchema: GenMessage<PowerTypeMixUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 50);

/**
 * PeerUnit is a unit of the same 系統コード that a power-type change would also change.
 *
 * @generated from message bffuser.v1.PeerUnit
 */
export type PeerUnit = Message<"bffuser.v1.PeerUnit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string unit_name = 2;
   */
  unitName: string;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 3;
   */
  powerType: PowerType;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.PeerUnit.
 * Use `create(PeerUnitSchema)` to create a new message.
 */
export const PeerUnitSchema: GenMessage<PeerUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 51);

/**
 * PowerTypeChangeConfirmationDetail is the error detail of
 * PlantUnitErrorReason.POWER_TYPE_CHANGE_NEEDS_CONFIRMATION: changing this unit's power
 * type to `to` also changes the other units of the same 系統コード linked to it by
 * overlapping valid periods, transitively (`units`; a unit not linked is not changed).
 * Resend with power_type_change_confirmed_units = units (id and updated_at) to change them.
 *
 * @generated from message bffuser.v1.PowerTypeChangeConfirmationDetail
 */
export type PowerTypeChangeConfirmationDetail = Message<"bffuser.v1.PowerTypeChangeConfirmationDetail"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: bffuser.v1.PowerType to = 2;
   */
  to: PowerType;

  /**
   * @generated from field: repeated bffuser.v1.PeerUnit units = 3;
   */
  units: PeerUnit[];
};

/**
 * Describes the message bffuser.v1.PowerTypeChangeConfirmationDetail.
 * Use `create(PowerTypeChangeConfirmationDetailSchema)` to create a new message.
 */
export const PowerTypeChangeConfirmationDetailSchema: GenMessage<PowerTypeChangeConfirmationDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 52);

/**
 * LastUnitOfBgPlantDetail is the error detail of PlantUnitErrorReason.LAST_UNIT_OF_BG_PLANT (E4):
 * from first_uncovered_date the 系統コード would have no valid unit while it belongs to the
 * 発電 BG bg_code.
 *
 * @generated from message bffuser.v1.LastUnitOfBgPlantDetail
 */
export type LastUnitOfBgPlantDetail = Message<"bffuser.v1.LastUnitOfBgPlantDetail"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * @generated from field: google.type.Date first_uncovered_date = 3;
   */
  firstUncoveredDate?: Date;
};

/**
 * Describes the message bffuser.v1.LastUnitOfBgPlantDetail.
 * Use `create(LastUnitOfBgPlantDetailSchema)` to create a new message.
 */
export const LastUnitOfBgPlantDetailSchema: GenMessage<LastUnitOfBgPlantDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 53);

/**
 * BgPowerTypeGroup is the 系統コード of one power type in a mixed 発電 BG.
 *
 * @generated from message bffuser.v1.BgPowerTypeGroup
 */
export type BgPowerTypeGroup = Message<"bffuser.v1.BgPowerTypeGroup"> & {
  /**
   * @generated from field: bffuser.v1.PowerType power_type = 1;
   */
  powerType: PowerType;

  /**
   * @generated from field: repeated string plant_codes = 2;
   */
  plantCodes: string[];
};

/**
 * Describes the message bffuser.v1.BgPowerTypeGroup.
 * Use `create(BgPowerTypeGroupSchema)` to create a new message.
 */
export const BgPowerTypeGroupSchema: GenMessage<BgPowerTypeGroup> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 54);

/**
 * BgPowerTypeMixDetail is the error detail of PlantUnitErrorReason.BG_POWER_TYPE_MIX and
 * GenerationSalesMasterErrorReason.BG_POWER_TYPE_MIX (E2): from first_mixed_date the plants
 * of the 発電 BG have two or more power types.
 *
 * @generated from message bffuser.v1.BgPowerTypeMixDetail
 */
export type BgPowerTypeMixDetail = Message<"bffuser.v1.BgPowerTypeMixDetail"> & {
  /**
   * @generated from field: string bg_code = 1;
   */
  bgCode: string;

  /**
   * @generated from field: repeated bffuser.v1.BgPowerTypeGroup groups = 2;
   */
  groups: BgPowerTypeGroup[];

  /**
   * @generated from field: google.type.Date first_mixed_date = 3;
   */
  firstMixedDate?: Date;
};

/**
 * Describes the message bffuser.v1.BgPowerTypeMixDetail.
 * Use `create(BgPowerTypeMixDetailSchema)` to create a new message.
 */
export const BgPowerTypeMixDetailSchema: GenMessage<BgPowerTypeMixDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 55);

/**
 * UndecidedPlant is a 系統コード of a 発電 BG whose power type is undecided (E3).
 *
 * @generated from message bffuser.v1.UndecidedPlant
 */
export type UndecidedPlant = Message<"bffuser.v1.UndecidedPlant"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * The first day (on or after today) it is undecided.
   *
   * @generated from field: google.type.Date first_undecided_date = 2;
   */
  firstUndecidedDate?: Date;

  /**
   * false = the 系統コード has no unit at all.
   *
   * @generated from field: bool has_any_unit = 3;
   */
  hasAnyUnit: boolean;
};

/**
 * Describes the message bffuser.v1.UndecidedPlant.
 * Use `create(UndecidedPlantSchema)` to create a new message.
 */
export const UndecidedPlantSchema: GenMessage<UndecidedPlant> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 56);

/**
 * UndecidedPlantDetail is the error detail of GenerationSalesMasterErrorReason.UNDECIDED_PLANT (E3).
 *
 * @generated from message bffuser.v1.UndecidedPlantDetail
 */
export type UndecidedPlantDetail = Message<"bffuser.v1.UndecidedPlantDetail"> & {
  /**
   * @generated from field: repeated bffuser.v1.UndecidedPlant plants = 1;
   */
  plants: UndecidedPlant[];
};

/**
 * Describes the message bffuser.v1.UndecidedPlantDetail.
 * Use `create(UndecidedPlantDetailSchema)` to create a new message.
 */
export const UndecidedPlantDetailSchema: GenMessage<UndecidedPlantDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 57);

/**
 * PlanCategoryMismatchDetail is the error detail of
 * GenerationSalesMasterErrorReason.PLAN_CATEGORY_MISMATCH and PlantUnitErrorReason.PLAN_CATEGORY_MISMATCH:
 * from first_date the 系統コード's power type does not suit the 計画区分 of the 発電販売計画マスタ.
 * submitter_code / plan_category name that master (set when it is not the one being saved).
 *
 * @generated from message bffuser.v1.PlanCategoryMismatchDetail
 */
export type PlanCategoryMismatchDetail = Message<"bffuser.v1.PlanCategoryMismatchDetail"> & {
  /**
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 2;
   */
  powerType: PowerType;

  /**
   * @generated from field: google.type.Date first_date = 3;
   */
  firstDate?: Date;

  /**
   * @generated from field: string submitter_code = 4;
   */
  submitterCode: string;

  /**
   * @generated from field: bfftypes.v1.GenerationSaleSubKind plan_category = 5;
   */
  planCategory: GenerationSaleSubKind;
};

/**
 * Describes the message bffuser.v1.PlanCategoryMismatchDetail.
 * Use `create(PlanCategoryMismatchDetailSchema)` to create a new message.
 */
export const PlanCategoryMismatchDetailSchema: GenMessage<PlanCategoryMismatchDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 58);

/**
 * GenerationSiteListInfo mirrors internalapi.v1 and is the list-only derived data of one 発電所, returned by
 * ListGenerationSites next to the 発電所 itself (one per item, same order): the unit
 * count and the units whose 系統コード is in another area (エリア不一致). It is not part
 * of GenerationSite, so Get / Create / Update cannot be mistaken for "no mismatch".
 *
 * @generated from message bffuser.v1.GenerationSiteListInfo
 */
export type GenerationSiteListInfo = Message<"bffuser.v1.GenerationSiteListInfo"> & {
  /**
   * @generated from field: string generation_site_id = 1;
   */
  generationSiteId: string;

  /**
   * Number of units that belong to the 発電所.
   *
   * @generated from field: int32 unit_count = 2;
   */
  unitCount: number;

  /**
   * In unit-name order.
   *
   * @generated from field: repeated bffuser.v1.SiteAreaMismatchUnit area_mismatched_units = 3;
   */
  areaMismatchedUnits: SiteAreaMismatchUnit[];
};

/**
 * Describes the message bffuser.v1.GenerationSiteListInfo.
 * Use `create(GenerationSiteListInfoSchema)` to create a new message.
 */
export const GenerationSiteListInfoSchema: GenMessage<GenerationSiteListInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 59);

/**
 * PlantMasterListInfo mirrors internalapi.v1 and is the list-only derived data of one 系統コード, returned by
 * ListPlantMasters next to the 系統コード itself (one per item, same order): the units that
 * use it while their 発電所 is in another area (エリア不一致).
 *
 * @generated from message bffuser.v1.PlantMasterListInfo
 */
export type PlantMasterListInfo = Message<"bffuser.v1.PlantMasterListInfo"> & {
  /**
   * @generated from field: string plant_master_id = 1;
   */
  plantMasterId: string;

  /**
   * In unit-name order.
   *
   * @generated from field: repeated bffuser.v1.PlantAreaMismatchUnit area_mismatched_units = 2;
   */
  areaMismatchedUnits: PlantAreaMismatchUnit[];
};

/**
 * Describes the message bffuser.v1.PlantMasterListInfo.
 * Use `create(PlantMasterListInfoSchema)` to create a new message.
 */
export const PlantMasterListInfoSchema: GenMessage<PlantMasterListInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 60);

/**
 * GenerationSite is a 発電所 (サイト) master record. Mirrors backend
 * internalapi.v1.GenerationSite 1:1.
 *
 * @generated from message bffuser.v1.GenerationSite
 */
export type GenerationSite = Message<"bffuser.v1.GenerationSite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_name = 2;
   */
  siteName: string;

  /**
   * 略称. Absent when not entered.
   *
   * @generated from field: optional string site_name_abbr = 3;
   */
  siteNameAbbr?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * 備考. Absent when not entered.
   *
   * @generated from field: optional string note = 5;
   */
  note?: string;

  /**
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.GenerationSite.
 * Use `create(GenerationSiteSchema)` to create a new message.
 */
export const GenerationSiteSchema: GenMessage<GenerationSite> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 61);

/**
 * PlantUnit is a 電源ユニット. Mirrors backend internalapi.v1.PlantUnit 1:1.
 *
 * @generated from message bffuser.v1.PlantUnit
 */
export type PlantUnit = Message<"bffuser.v1.PlantUnit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string generation_site_id = 2;
   */
  generationSiteId: string;

  /**
   * 系統コード (広域機関の発電所) の id. Absent when not set.
   *
   * @generated from field: optional string plant_master_id = 3;
   */
  plantMasterId?: string;

  /**
   * @generated from field: string unit_name = 4;
   */
  unitName: string;

  /**
   * @generated from field: string unit_name_abbr = 5;
   */
  unitNameAbbr: string;

  /**
   * @generated from field: bffuser.v1.GeneratorCategory generator_category = 6;
   */
  generatorCategory: GeneratorCategory;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 7;
   */
  powerType: PowerType;

  /**
   * @generated from field: int64 authorized_output_kw = 8;
   */
  authorizedOutputKw: bigint;

  /**
   * @generated from field: optional string receiving_point_id = 9;
   */
  receivingPointId?: string;

  /**
   * @generated from field: optional string power_source_id = 10;
   */
  powerSourceId?: string;

  /**
   * @generated from field: optional string generator_identifier = 11;
   */
  generatorIdentifier?: string;

  /**
   * @generated from field: google.type.Date operation_start_date = 12;
   */
  operationStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date operation_end_date = 13;
   */
  operationEndDate?: Date;

  /**
   * @generated from field: google.type.Date valid_from = 14;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 15;
   */
  validTo?: Date;

  /**
   * @generated from field: optional string note = 16;
   */
  note?: string;

  /**
   * Derived (not stored): the 系統コード's area, else the 発電所's area.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 17;
   */
  areaCode: AreaCode;

  /**
   * Derived (not stored): the 系統コード's BG memberships.
   *
   * @generated from field: repeated bffuser.v1.PlantUnitAffiliation affiliations = 18;
   */
  affiliations: PlantUnitAffiliation[];

  /**
   * @generated from field: optional string created_by = 19;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 21;
   */
  updatedBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */
  updatedAt?: Timestamp;

  /**
   * Derived (not stored): the unit's 発電所 and 系統コード are in different areas
   * (エリア不一致). false when the unit has no 系統コード.
   *
   * @generated from field: bool site_area_mismatch = 23;
   */
  siteAreaMismatch: boolean;
};

/**
 * Describes the message bffuser.v1.PlantUnit.
 * Use `create(PlantUnitSchema)` to create a new message.
 */
export const PlantUnitSchema: GenMessage<PlantUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 62);

/**
 * PlantUnitAffiliation is one BG membership of a 電源ユニット's 系統コード.
 *
 * @generated from message bffuser.v1.PlantUnitAffiliation
 */
export type PlantUnitAffiliation = Message<"bffuser.v1.PlantUnitAffiliation"> & {
  /**
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * @generated from field: string bg_name = 3;
   */
  bgName: string;

  /**
   * @generated from field: google.type.Date valid_from = 4;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;

  /**
   * True when the BG is an own 発電 BG (license 発電 and an own constituent).
   *
   * @generated from field: bool is_own_generation_bg = 6;
   */
  isOwnGenerationBg: boolean;
};

/**
 * Describes the message bffuser.v1.PlantUnitAffiliation.
 * Use `create(PlantUnitAffiliationSchema)` to create a new message.
 */
export const PlantUnitAffiliationSchema: GenMessage<PlantUnitAffiliation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 63);

/**
 * NewGenerationSite is a 発電所 registered together with a 電源ユニット; the rules
 * are those of CreateGenerationSiteRequest.
 *
 * @generated from message bffuser.v1.NewGenerationSite
 */
export type NewGenerationSite = Message<"bffuser.v1.NewGenerationSite"> & {
  /**
   * @generated from field: string site_name = 1;
   */
  siteName: string;

  /**
   * @generated from field: optional string site_name_abbr = 2;
   */
  siteNameAbbr?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: optional string note = 4;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.NewGenerationSite.
 * Use `create(NewGenerationSiteSchema)` to create a new message.
 */
export const NewGenerationSiteSchema: GenMessage<NewGenerationSite> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 64);

/**
 * SiteAreaMismatch tells the 発電所's area differs from the 系統コード's area. It is
 * a notice: the save has succeeded.
 *
 * @generated from message bffuser.v1.SiteAreaMismatch
 */
export type SiteAreaMismatch = Message<"bffuser.v1.SiteAreaMismatch"> & {
  /**
   * @generated from field: string site_name = 1;
   */
  siteName: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode site_area_code = 2;
   */
  siteAreaCode: AreaCode;

  /**
   * @generated from field: string plant_code = 3;
   */
  plantCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode plant_area_code = 4;
   */
  plantAreaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.SiteAreaMismatch.
 * Use `create(SiteAreaMismatchSchema)` to create a new message.
 */
export const SiteAreaMismatchSchema: GenMessage<SiteAreaMismatch> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_model, 65);

/**
 * PowerType is the regulatory power-type classification carried by
 * generation BGs. Demand / DR / self-wheeling BGs do not surface this
 * field.
 *
 * Kept context-local (= not under a separate file) because no other BFF
 * service has a use for it yet; promote when a second consumer appears.
 *
 * @generated from enum bffuser.v1.PowerType
 */
export enum PowerType {
  /**
   * @generated from enum value: POWER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POWER_TYPE_NON_ADJUSTABLE = 1;
   */
  NON_ADJUSTABLE = 1,

  /**
   * @generated from enum value: POWER_TYPE_ADJUSTABLE = 2;
   */
  ADJUSTABLE = 2,

  /**
   * @generated from enum value: POWER_TYPE_FIT_EXCEPTION_1 = 3;
   */
  FIT_EXCEPTION_1 = 3,

  /**
   * @generated from enum value: POWER_TYPE_FIT_EXCEPTION_2 = 4;
   */
  FIT_EXCEPTION_2 = 4,

  /**
   * @generated from enum value: POWER_TYPE_FIT_EXCEPTION_3 = 5;
   */
  FIT_EXCEPTION_3 = 5,

  /**
   * @generated from enum value: POWER_TYPE_FIP = 6;
   */
  FIP = 6,
}

/**
 * Describes the enum bffuser.v1.PowerType.
 */
export const PowerTypeSchema: GenEnum<PowerType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 0);

/**
 * GeneratorCategory is the 発電形式 of a 電源ユニット: the 11 registration
 * categories of the 電源ユニット画面 (the 同時同量 電源区分 has no 揚水 / 蓄電池, so
 * this is a separate concept).
 *
 * Mirrors backend internalapi.v1.GeneratorCategory 1:1 (wire values match).
 *
 * @generated from enum bffuser.v1.GeneratorCategory
 */
export enum GeneratorCategory {
  /**
   * @generated from enum value: GENERATOR_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_NUCLEAR = 1;
   */
  NUCLEAR = 1,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_HYDRO = 2;
   */
  HYDRO = 2,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_THERMAL_COAL = 3;
   */
  THERMAL_COAL = 3,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_THERMAL_GAS = 4;
   */
  THERMAL_GAS = 4,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_THERMAL_OIL = 5;
   */
  THERMAL_OIL = 5,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_GEOTHERMAL = 6;
   */
  GEOTHERMAL = 6,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_WIND = 7;
   */
  WIND = 7,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_SOLAR = 8;
   */
  SOLAR = 8,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_PUMPED_STORAGE = 9;
   */
  PUMPED_STORAGE = 9,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_STORAGE = 10;
   */
  STORAGE = 10,

  /**
   * @generated from enum value: GENERATOR_CATEGORY_OTHER = 11;
   */
  OTHER = 11,
}

/**
 * Describes the enum bffuser.v1.GeneratorCategory.
 */
export const GeneratorCategorySchema: GenEnum<GeneratorCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 1);

/**
 * MasterSubjectKind mirrors backend internalapi.v1.MasterSubjectKind 1:1
 * (index.md AC-MOI-009 「{対象マスタ}」).
 *
 * @generated from enum bffuser.v1.MasterSubjectKind
 */
export enum MasterSubjectKind {
  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_BG = 1;
   */
  BG = 1,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_BUSINESS = 2;
   */
  BUSINESS = 2,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_SUBMITTER = 3;
   */
  SUBMITTER = 3,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_PLANT = 4;
   */
  PLANT = 4,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_TRADING_PARTNER = 5;
   */
  TRADING_PARTNER = 5,

  /**
   * @generated from enum value: MASTER_SUBJECT_KIND_GENERATION_SITE = 6;
   */
  GENERATION_SITE = 6,
}

/**
 * Describes the enum bffuser.v1.MasterSubjectKind.
 */
export const MasterSubjectKindSchema: GenEnum<MasterSubjectKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 2);

/**
 * MasterReferrerKind mirrors backend internalapi.v1.MasterReferrerKind
 * 1:1 (index.md AC-MOI-009 breakdown).
 *
 * @generated from enum bffuser.v1.MasterReferrerKind
 */
export enum MasterReferrerKind {
  /**
   * @generated from enum value: MASTER_REFERRER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BG マスタの参照元 (6)。
   *
   * 計画提出者所属BG
   *
   * @generated from enum value: MASTER_REFERRER_KIND_SUBMITTER_BG_MEMBER = 1;
   */
  SUBMITTER_BG_MEMBER = 1,

  /**
   * 発電販売計画
   *
   * @generated from enum value: MASTER_REFERRER_KIND_GENERATION_SALES_BG = 2;
   */
  GENERATION_SALES_BG = 2,

  /**
   * 需要調達計画
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_PROCUREMENT_BG = 3;
   */
  DEMAND_PROCUREMENT_BG = 3,

  /**
   * 需要抑制計画 (抑制BG)
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_SUPPRESSION_SUPPRESSION_BG = 5;
   */
  DEMAND_SUPPRESSION_SUPPRESSION_BG = 5,

  /**
   * 需要抑制計画 (相手BG)
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_SUPPRESSION_PARTNER_BG = 6;
   */
  DEMAND_SUPPRESSION_PARTNER_BG = 6,

  /**
   * 需要抑制計画 (配下相手BG)
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_SUPPRESSION_MEMBER_BG = 7;
   */
  DEMAND_SUPPRESSION_MEMBER_BG = 7,

  /**
   * 事業者マスタの参照元 (5)。
   *
   * BG所属事業者
   *
   * @generated from enum value: MASTER_REFERRER_KIND_BG_MEMBER = 8;
   */
  BG_MEMBER = 8,

  /**
   * 計画提出者
   *
   * @generated from enum value: MASTER_REFERRER_KIND_SUBMITTER_MASTER = 9;
   */
  SUBMITTER_MASTER = 9,

  /**
   * 発電機
   *
   * @generated from enum value: MASTER_REFERRER_KIND_PLANT_MASTER = 10;
   */
  PLANT_MASTER = 10,

  /**
   * 発電機所属事業者
   *
   * @generated from enum value: MASTER_REFERRER_KIND_PLANT_MEMBER = 11;
   */
  PLANT_MEMBER = 11,

  /**
   * 需要抑制契約事業者
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_SUPPRESSION_CONTRACT_BUSINESS = 12;
   */
  DEMAND_SUPPRESSION_CONTRACT_BUSINESS = 12,

  /**
   * 計画提出者マスタの参照元 (2)。
   *
   * 発電販売計画
   *
   * @generated from enum value: MASTER_REFERRER_KIND_GENERATION_SALES_SUBMITTER = 13;
   */
  GENERATION_SALES_SUBMITTER = 13,

  /**
   * 需要抑制計画
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_SUPPRESSION_SUBMITTER = 14;
   */
  DEMAND_SUPPRESSION_SUBMITTER = 14,

  /**
   * 発電機マスタの参照元 (3)。
   *
   * BG配下発電所
   *
   * @generated from enum value: MASTER_REFERRER_KIND_BG_PLANT_MEMBERSHIP = 15;
   */
  BG_PLANT_MEMBERSHIP = 15,

  /**
   * 発電販売計画配下発電所
   *
   * @generated from enum value: MASTER_REFERRER_KIND_GENERATION_SALES_PLANT = 16;
   */
  GENERATION_SALES_PLANT = 16,

  /**
   * 発電機実績
   *
   * @generated from enum value: MASTER_REFERRER_KIND_PLANT_ACTUAL_SLOT = 17;
   */
  PLANT_ACTUAL_SLOT = 17,

  /**
   * 取引先マスタの参照元 (2)。
   *
   * 発電販売計画 code による取引先コード被参照
   *
   * @generated from enum value: MASTER_REFERRER_KIND_GENERATION_SALES_TRADING_PARTNER_CODE = 18;
   */
  GENERATION_SALES_TRADING_PARTNER_CODE = 18,

  /**
   * 需要調達計画 code による取引先コード被参照
   *
   * @generated from enum value: MASTER_REFERRER_KIND_DEMAND_PROCUREMENT_TRADING_PARTNER_CODE = 19;
   */
  DEMAND_PROCUREMENT_TRADING_PARTNER_CODE = 19,

  /**
   * 発電所 (サイト) と発電所マスタ (系統コード) の参照元 (1)。
   *
   * 電源ユニット
   *
   * @generated from enum value: MASTER_REFERRER_KIND_PLANT_UNIT = 20;
   */
  PLANT_UNIT = 20,

  /**
   * 事業者マスタの参照元 (分割供給契約、負荷追随分・ベース分のどちらの側でも)。
   *
   * 分割供給契約
   *
   * @generated from enum value: MASTER_REFERRER_KIND_SPLIT_SUPPLY_CONTRACT = 21;
   */
  SPLIT_SUPPLY_CONTRACT = 21,
}

/**
 * Describes the enum bffuser.v1.MasterReferrerKind.
 */
export const MasterReferrerKindSchema: GenEnum<MasterReferrerKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 3);

/**
 * BusinessMasterErrorReason mirrors backend
 * internalapi.v1.BusinessMasterErrorReason 1:1 (wire values match). See
 * BgMasterErrorReason's godoc for the typed-vocabulary contract.
 *
 * @generated from enum bffuser.v1.BusinessMasterErrorReason
 */
export enum BusinessMasterErrorReason {
  /**
   * @generated from enum value: BUSINESS_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BUSINESS_MASTER_ERROR_REASON_REGISTRATION_NUMBER_ALREADY_EXISTS = 1;
   */
  REGISTRATION_NUMBER_ALREADY_EXISTS = 1,
}

/**
 * Describes the enum bffuser.v1.BusinessMasterErrorReason.
 */
export const BusinessMasterErrorReasonSchema: GenEnum<BusinessMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 4);

/**
 * BgMasterErrorReason mirrors backend internalapi.v1.BgMasterErrorReason
 * 1:1 (wire values match). See the backend enum's godoc for the typed-
 * vocabulary contract (not a wire message field; google.rpc.ErrorInfo.reason
 * stays a generic string, docs/adr/structured-app-error-typed-reason.md
 * decision 1). The generated TS enum + a `Record<BgMasterErrorReason,
 * i18nKey>` gives the frontend compile-time coverage of every reason.
 *
 * @generated from enum bffuser.v1.BgMasterErrorReason
 */
export enum BgMasterErrorReason {
  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_BG_CODE_INVALID_FORMAT = 1;
   */
  BG_CODE_INVALID_FORMAT = 1,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_WHEELING_LINK_CODE_INVALID_FORMAT = 2;
   */
  WHEELING_LINK_CODE_INVALID_FORMAT = 2,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_BG_CODE_ALREADY_EXISTS_CROSS_MASTER = 3;
   */
  BG_CODE_ALREADY_EXISTS_CROSS_MASTER = 3,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_BG_MEMBER_LICENSE_MISMATCH = 4;
   */
  BG_MEMBER_LICENSE_MISMATCH = 4,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_PLANT_AREA_MISMATCH = 5;
   */
  PLANT_AREA_MISMATCH = 5,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_OWN_BG_PERIOD_OVERLAP = 6;
   */
  OWN_BG_PERIOD_OVERLAP = 6,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_ONLY_REPRESENTATIVE_MEMBER = 7;
   */
  ONLY_REPRESENTATIVE_MEMBER = 7,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_BG_POWER_TYPE_MIX = 8;
   */
  BG_POWER_TYPE_MIX = 8,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_UNDECIDED_PLANT = 9;
   */
  UNDECIDED_PLANT = 9,

  /**
   * @generated from enum value: BG_MASTER_ERROR_REASON_PLAN_CATEGORY_MISMATCH = 10;
   */
  PLAN_CATEGORY_MISMATCH = 10,
}

/**
 * Describes the enum bffuser.v1.BgMasterErrorReason.
 */
export const BgMasterErrorReasonSchema: GenEnum<BgMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 5);

/**
 * SubmitterMasterErrorReason mirrors backend
 * internalapi.v1.SubmitterMasterErrorReason 1:1 (wire values match). See
 * BgMasterErrorReason's godoc for the typed-vocabulary contract.
 *
 * @generated from enum bffuser.v1.SubmitterMasterErrorReason
 */
export enum SubmitterMasterErrorReason {
  /**
   * @generated from enum value: SUBMITTER_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBMITTER_MASTER_ERROR_REASON_SUBMITTER_CODE_INVALID_FORMAT = 1;
   */
  SUBMITTER_CODE_INVALID_FORMAT = 1,

  /**
   * @generated from enum value: SUBMITTER_MASTER_ERROR_REASON_BUSINESS_MASTER_NOT_FOUND = 2;
   */
  BUSINESS_MASTER_NOT_FOUND = 2,

  /**
   * @generated from enum value: SUBMITTER_MASTER_ERROR_REASON_SUBMITTER_CODE_ALREADY_EXISTS = 3;
   */
  SUBMITTER_CODE_ALREADY_EXISTS = 3,

  /**
   * @generated from enum value: SUBMITTER_MASTER_ERROR_REASON_MEMBER_LICENSE_AREA_MISMATCH = 4;
   */
  MEMBER_LICENSE_AREA_MISMATCH = 4,
}

/**
 * Describes the enum bffuser.v1.SubmitterMasterErrorReason.
 */
export const SubmitterMasterErrorReasonSchema: GenEnum<SubmitterMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 6);

/**
 * TradingPartnerErrorReason mirrors backend
 * internalapi.v1.TradingPartnerErrorReason 1:1 (wire values match). See
 * BgMasterErrorReason's godoc for the typed-vocabulary contract.
 *
 * @generated from enum bffuser.v1.TradingPartnerErrorReason
 */
export enum TradingPartnerErrorReason {
  /**
   * @generated from enum value: TRADING_PARTNER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The account code being newly registered/promoted as representative
   * already exists as another trading partner's representative account
   * code (spec AC-OMT-028: representative codes are unique across every
   * trading partner in the organization).
   *
   * @generated from enum value: TRADING_PARTNER_ERROR_REASON_REPRESENTATIVE_CODE_ALREADY_EXISTS = 2;
   */
  REPRESENTATIVE_CODE_ALREADY_EXISTS = 2,

  /**
   * The account code conflicts with an existing BG master code
   * (AC-MOI-013).
   *
   * @generated from enum value: TRADING_PARTNER_ERROR_REASON_ACCOUNT_CODE_ALREADY_EXISTS_CROSS_MASTER = 3;
   */
  ACCOUNT_CODE_ALREADY_EXISTS_CROSS_MASTER = 3,

  /**
   * An Update would remove an account code that a generation-sales or
   * demand-procurement plan master still references.
   *
   * @generated from enum value: TRADING_PARTNER_ERROR_REASON_ACCOUNT_CODE_REFERENCED_BY_PLAN_MASTER = 4;
   */
  ACCOUNT_CODE_REFERENCED_BY_PLAN_MASTER = 4,
}

/**
 * Describes the enum bffuser.v1.TradingPartnerErrorReason.
 */
export const TradingPartnerErrorReasonSchema: GenEnum<TradingPartnerErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 7);

/**
 * DemandSuppressionPartnerSide identifies which side of a suppression
 * contract a trading-partner BG plays: procurement (調達) or sales (販売).
 * Mirrors internalapi.v1.DemandSuppressionPartnerSide 1:1.
 *
 * @generated from enum bffuser.v1.DemandSuppressionPartnerSide
 */
export enum DemandSuppressionPartnerSide {
  /**
   * @generated from enum value: DEMAND_SUPPRESSION_PARTNER_SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_PARTNER_SIDE_PROCUREMENT = 1;
   */
  PROCUREMENT = 1,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_PARTNER_SIDE_SALES = 2;
   */
  SALES = 2,
}

/**
 * Describes the enum bffuser.v1.DemandSuppressionPartnerSide.
 */
export const DemandSuppressionPartnerSideSchema: GenEnum<DemandSuppressionPartnerSide> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 8);

/**
 * GenerationSalesMasterErrorReason mirrors backend
 * internalapi.v1.GenerationSalesMasterErrorReason 1:1 (wire values match).
 * See BgMasterErrorReason's godoc for the typed-vocabulary contract.
 *
 * @generated from enum bffuser.v1.GenerationSalesMasterErrorReason
 */
export enum GenerationSalesMasterErrorReason {
  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_SUBMITTER_NOT_FOUND = 1;
   */
  SUBMITTER_NOT_FOUND = 1,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_SUBMITTER_LICENSE_MISMATCH = 2;
   */
  SUBMITTER_LICENSE_MISMATCH = 2,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_MEMBER_BG_NOT_FOUND = 3;
   */
  MEMBER_BG_NOT_FOUND = 3,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_PLANT_NOT_FOUND = 4;
   */
  PLANT_NOT_FOUND = 4,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_SUBMITTER_PLAN_CATEGORY_ALREADY_EXISTS = 5;
   */
  SUBMITTER_PLAN_CATEGORY_ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_MEMBER_BG_LICENSE_MISMATCH = 6;
   */
  MEMBER_BG_LICENSE_MISMATCH = 6,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_PLANT_AREA_MISMATCH = 7;
   */
  PLANT_AREA_MISMATCH = 7,

  /**
   * The effective periods of plant entries with the same plant code overlap.
   * ErrorInfo metadata: plant_code.
   *
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_PLANT_PERIOD_OVERLAP = 8;
   */
  PLANT_PERIOD_OVERLAP = 8,

  /**
   * The effective periods of BG entries with the same BG overlap.
   * ErrorInfo metadata: bg_code.
   *
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_BG_PERIOD_OVERLAP = 9;
   */
  BG_PERIOD_OVERLAP = 9,

  /**
   * A plant entry names a 所属 BG that is not among the BG entries.
   * ErrorInfo metadata: plant_code.
   *
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_PLANT_BG_NOT_IN_BGS = 10;
   */
  PLANT_BG_NOT_IN_BGS = 10,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_BG_POWER_TYPE_MIX = 11;
   */
  BG_POWER_TYPE_MIX = 11,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_UNDECIDED_PLANT = 12;
   */
  UNDECIDED_PLANT = 12,

  /**
   * @generated from enum value: GENERATION_SALES_MASTER_ERROR_REASON_PLAN_CATEGORY_MISMATCH = 13;
   */
  PLAN_CATEGORY_MISMATCH = 13,
}

/**
 * Describes the enum bffuser.v1.GenerationSalesMasterErrorReason.
 */
export const GenerationSalesMasterErrorReasonSchema: GenEnum<GenerationSalesMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 9);

/**
 * DemandProcurementMasterErrorReason mirrors backend
 * internalapi.v1.DemandProcurementMasterErrorReason 1:1 (wire values
 * match). See BgMasterErrorReason's godoc for the typed-vocabulary
 * contract.
 *
 * @generated from enum bffuser.v1.DemandProcurementMasterErrorReason
 */
export enum DemandProcurementMasterErrorReason {
  /**
   * @generated from enum value: DEMAND_PROCUREMENT_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_PROCUREMENT_MASTER_ERROR_REASON_REP_BG_NOT_FOUND = 1;
   */
  REP_BG_NOT_FOUND = 1,

  /**
   * @generated from enum value: DEMAND_PROCUREMENT_MASTER_ERROR_REASON_REP_BG_LICENSE_MISMATCH = 2;
   */
  REP_BG_LICENSE_MISMATCH = 2,

  /**
   * @generated from enum value: DEMAND_PROCUREMENT_MASTER_ERROR_REASON_BG_ALREADY_HAS_PROCUREMENT_MASTER = 3;
   */
  BG_ALREADY_HAS_PROCUREMENT_MASTER = 3,
}

/**
 * Describes the enum bffuser.v1.DemandProcurementMasterErrorReason.
 */
export const DemandProcurementMasterErrorReasonSchema: GenEnum<DemandProcurementMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 10);

/**
 * DemandSuppressionMasterErrorReason mirrors backend
 * internalapi.v1.DemandSuppressionMasterErrorReason 1:1 (wire values
 * match). See BgMasterErrorReason's godoc for the typed-vocabulary
 * contract.
 *
 * @generated from enum bffuser.v1.DemandSuppressionMasterErrorReason
 */
export enum DemandSuppressionMasterErrorReason {
  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_SUBMITTER_NOT_FOUND = 1;
   */
  SUBMITTER_NOT_FOUND = 1,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_SUBMITTER_LICENSE_MISMATCH = 2;
   */
  SUBMITTER_LICENSE_MISMATCH = 2,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_SUPPRESSION_BG_NOT_FOUND = 3;
   */
  SUPPRESSION_BG_NOT_FOUND = 3,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_SUPPRESSION_BG_LICENSE_MISMATCH = 4;
   */
  SUPPRESSION_BG_LICENSE_MISMATCH = 4,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_PARTNER_BG_NOT_FOUND = 5;
   */
  PARTNER_BG_NOT_FOUND = 5,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_BUSINESS_NOT_FOUND = 6;
   */
  BUSINESS_NOT_FOUND = 6,

  /**
   * @generated from enum value: DEMAND_SUPPRESSION_MASTER_ERROR_REASON_SUBMITTER_ALREADY_HAS_SUPPRESSION_MASTER = 7;
   */
  SUBMITTER_ALREADY_HAS_SUPPRESSION_MASTER = 7,
}

/**
 * Describes the enum bffuser.v1.DemandSuppressionMasterErrorReason.
 */
export const DemandSuppressionMasterErrorReasonSchema: GenEnum<DemandSuppressionMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 11);

/**
 * VoltageClass is the voltage level classification for plant masters
 * (発電所の電圧階級). Mirrors internalapi.v1.VoltageClass 1:1.
 *
 * @generated from enum bffuser.v1.VoltageClass
 */
export enum VoltageClass {
  /**
   * @generated from enum value: VOLTAGE_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 特別高圧 (extra-high voltage).
   *
   * @generated from enum value: VOLTAGE_CLASS_EXTRA_HIGH = 1;
   */
  EXTRA_HIGH = 1,

  /**
   * 高圧 (high voltage).
   *
   * @generated from enum value: VOLTAGE_CLASS_HIGH = 2;
   */
  HIGH = 2,

  /**
   * 低圧 (low voltage).
   *
   * @generated from enum value: VOLTAGE_CLASS_LOW = 3;
   */
  LOW = 3,
}

/**
 * Describes the enum bffuser.v1.VoltageClass.
 */
export const VoltageClassSchema: GenEnum<VoltageClass> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 12);

/**
 * PlantMasterErrorReason mirrors backend
 * internalapi.v1.PlantMasterErrorReason 1:1 (wire values match). See
 * BgMasterErrorReason's godoc for the typed-vocabulary contract.
 *
 * @generated from enum bffuser.v1.PlantMasterErrorReason
 */
export enum PlantMasterErrorReason {
  /**
   * @generated from enum value: PLANT_MASTER_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANT_MASTER_ERROR_REASON_PLANT_CODE_INVALID_FORMAT = 1;
   */
  PLANT_CODE_INVALID_FORMAT = 1,

  /**
   * @generated from enum value: PLANT_MASTER_ERROR_REASON_MEMBER_BUSINESS_MASTER_NOT_FOUND = 2;
   */
  MEMBER_BUSINESS_MASTER_NOT_FOUND = 2,

  /**
   * See internalapi.v1.PlantMasterErrorReason (the Connect error carries the same typed detail).
   *
   * @generated from enum value: PLANT_MASTER_ERROR_REASON_AREA_CHANGE_BLOCKED_BY_REGISTRATION = 3;
   */
  AREA_CHANGE_BLOCKED_BY_REGISTRATION = 3,

  /**
   * @generated from enum value: PLANT_MASTER_ERROR_REASON_AREA_CHANGE_NEEDS_CONFIRMATION = 4;
   */
  AREA_CHANGE_NEEDS_CONFIRMATION = 4,
}

/**
 * Describes the enum bffuser.v1.PlantMasterErrorReason.
 */
export const PlantMasterErrorReasonSchema: GenEnum<PlantMasterErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 13);

/**
 * AreaChangeRegistrationKind is what lists a 系統コード in a plan submission.
 *
 * @generated from enum bffuser.v1.AreaChangeRegistrationKind
 */
export enum AreaChangeRegistrationKind {
  /**
   * @generated from enum value: AREA_CHANGE_REGISTRATION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A 発電販売計画マスタ (code = the 提出者コード).
   *
   * @generated from enum value: AREA_CHANGE_REGISTRATION_KIND_GENERATION_SALES_MASTER = 1;
   */
  GENERATION_SALES_MASTER = 1,

  /**
   * A BG (code = the BG コード).
   *
   * @generated from enum value: AREA_CHANGE_REGISTRATION_KIND_BG = 2;
   */
  BG = 2,
}

/**
 * Describes the enum bffuser.v1.AreaChangeRegistrationKind.
 */
export const AreaChangeRegistrationKindSchema: GenEnum<AreaChangeRegistrationKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 14);

/**
 * GenerationSiteErrorReason mirrors internalapi.v1.GenerationSiteErrorReason.
 *
 * @generated from enum bffuser.v1.GenerationSiteErrorReason
 */
export enum GenerationSiteErrorReason {
  /**
   * @generated from enum value: GENERATION_SITE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SITE_ERROR_REASON_AREA_CHANGE_NEEDS_CONFIRMATION = 1;
   */
  AREA_CHANGE_NEEDS_CONFIRMATION = 1,
}

/**
 * Describes the enum bffuser.v1.GenerationSiteErrorReason.
 */
export const GenerationSiteErrorReasonSchema: GenEnum<GenerationSiteErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 15);

/**
 * PlantUnitErrorReason mirrors backend internalapi.v1.PlantUnitErrorReason 1:1
 * (wire values match). See BgMasterErrorReason's godoc for the typed-vocabulary
 * contract.
 *
 * @generated from enum bffuser.v1.PlantUnitErrorReason
 */
export enum PlantUnitErrorReason {
  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_MANAGED = 1;
   */
  MANAGED = 1,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_POWER_TYPE_MIX = 2;
   */
  POWER_TYPE_MIX = 2,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_LAST_UNIT_OF_BG_PLANT = 3;
   */
  LAST_UNIT_OF_BG_PLANT = 3,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_BG_POWER_TYPE_MIX = 4;
   */
  BG_POWER_TYPE_MIX = 4,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_POWER_TYPE_CHANGE_NEEDS_CONFIRMATION = 5;
   */
  POWER_TYPE_CHANGE_NEEDS_CONFIRMATION = 5,

  /**
   * @generated from enum value: PLANT_UNIT_ERROR_REASON_PLAN_CATEGORY_MISMATCH = 6;
   */
  PLAN_CATEGORY_MISMATCH = 6,
}

/**
 * Describes the enum bffuser.v1.PlantUnitErrorReason.
 */
export const PlantUnitErrorReasonSchema: GenEnum<PlantUnitErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_occto_master_model, 16);

